import { formatDistanceToNowStrict, format } from "date-fns";
import { es, enGB, ca, de, fr, it } from "date-fns/locale";

const DATE_LOCALES = { es, en: enGB, ca, de, fr, it };
let REGION = { currency: "EUR", locales: {} };
export const setFormatRegion = (r) => {
  REGION = r;
};

const loc = (lang) => DATE_LOCALES[lang] || es;
const numLocale = (lang) => REGION.locales?.[lang] || lang;

export function formatPrice(listing, t, lang) {
  const { price, category } = listing;
  if (price === null || price === undefined) return category === "gratis" ? t("price.free") : t("price.negotiable");
  if (Number(price) === 0) return t("price.free");
  const s = new Intl.NumberFormat(numLocale(lang), {
    style: "currency",
    currency: REGION.currency,
    maximumFractionDigits: price % 1 === 0 ? 0 : 2,
    useGrouping: "always",
  }).format(price);
  const unit = listing.attributes?.price_unit;
  return unit && unit !== "total" ? `${s} ${t(`unit.${unit}`)}` : s;
}

export const relativeDate = (iso, lang) =>
  formatDistanceToNowStrict(new Date(iso), { addSuffix: true, locale: loc(lang) });

export const monthYear = (iso, lang) => format(new Date(iso), "MMMM yyyy", { locale: loc(lang) });
